import { z } from 'zod';

/**
 * Schema de validation pour les paramètres de redirection
 * Utilisé dans les routes de login/register
 */
export const redirectSearchSchema = z.object({
  redirect: z.string().optional().catch(undefined)
});

/**
 * Schema de validation pour les filtres de la liste d'idées
 * Supporte: recherche, catégorie, statut, priorité, tri, projectId, campaignId
 */
export const ideasSearchSchema = z.object({
  search: z.string().optional().catch(undefined),
  category: z.string().optional().catch(undefined),
  status: z.enum(['new', 'pending', 'analyzed', 'enriched']).optional().catch(undefined),
  priority: z.enum(['high', 'medium', 'low']).optional().catch(undefined),
  sortBy: z.enum(['votes', 'recent', 'priority']).optional().default('votes').catch('votes'),
  projectId: z.string().optional().catch(undefined),
  campaignId: z.string().optional().catch(undefined)
});

/**
 * Schema de validation pour les filtres de la roadmap
 * Supporte: statut, période, vue
 */
export const roadmapSearchSchema = z.object({
  status: z.enum(['planned', 'in-progress', 'completed']).optional().catch(undefined),
  period: z.enum(['quarter', 'year', 'all']).optional().default('quarter').catch('quarter'),
  view: z.enum(['timeline', 'list', 'kanban']).optional().default('timeline').catch('timeline')
});
